// extracted by mini-css-extract-plugin
module.exports = {"colorList":"_3bcEQ"};